import type {FileViewForm} from 'shared/constants';
import type {ConfirmableRequest, FinishedSaveResponse, IdentifiedFile, ViewableFile} from 'src/typings';
import type {AjaxService} from 'core/data-services/ajax.service';
import {ngAsync} from 'shared/utils/ng-@decorators';
import {transferify} from 'shared/utils/data-service-utils';

export interface FileQueryParams {
    directory?: number[];
    rootDirectory?: number[];
    excludedFile?: number[];
    fileViewForm?: FileViewForm[];
}

export class FileDataService {
    public static serviceName = 'fileDataService';
    public static readonly ROUTE = 'files';
    public static readonly CREATE_ROUTE = 'files/create';

    /*@ngInject*/
    constructor(private ajaxService: AjaxService) {
    }

    @ngAsync()
    public async getFile(id: number): Promise<ViewableFile> {
        return this.ajaxService
            .createRequest(`${FileDataService.ROUTE}/${id}`)
            .get<ViewableFile>();
    }

    @ngAsync()
    public async queryFiles(params: FileQueryParams): Promise<ViewableFile[]> {
        return this.ajaxService
            .createRequest(`${FileDataService.ROUTE}`)
            .get<ViewableFile[]>(params);
    }

    @ngAsync()
    public async createFile(directoryId?: number, name?: string): Promise<FinishedSaveResponse<ViewableFile>> {
        return this.ajaxService
            .createRequest(`${FileDataService.CREATE_ROUTE}`)
            .post({directory: directoryId, name});
    }

    @ngAsync()
    public async removeFile(file: IdentifiedFile): Promise<void> {
        return this.ajaxService
            .createRequest(`${FileDataService.ROUTE}/${file.id}`)
            .delete();
    }

    @ngAsync()
    public async moveFile(file: IdentifiedFile, targetDirectoryId: number): Promise<FinishedSaveResponse<ViewableFile>> {
        return this.ajaxService
            .createRequest(`${FileDataService.ROUTE}/move`)
            .post({id: file.id, targetDirectory: targetDirectoryId});
    }

    @ngAsync()
    public async editFileMetadata(request: IdentifiedFile & ConfirmableRequest): Promise<FinishedSaveResponse<ViewableFile>> {
        return this.ajaxService
            .createRequest(`${FileDataService.ROUTE}`)
            .post(transferify(request));
    }

    @ngAsync()
    public async modifyFileContent(file: IdentifiedFile, content: string): Promise<IdentifiedFile> {
        return this.ajaxService
            .createRequest(`${FileDataService.ROUTE}/${file.id}/modify`)
            .withHeaders({'Content-Type': 'text/plain'})
            .post(content);
    }
}
